import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Navbar from '../Navbar'
import Footer from '../page-main/footer'
import ProductosGrid from '../Productos'

export default function ProductosPage() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, easing: 'ease-out-cubic' })
  }, [])

  return (
    <>
      <Helmet>
        <title>Productos | Adrox Perú</title>
        <meta name="description" content="Explora nuestro catálogo de productos y soluciones de tecnología. Encuentra los mejores productos IT para tu negocio." />
        <meta property="og:title" content="Productos | Adrox Perú" />
        <meta property="og:description" content="Catálogo de productos tecnológicos para tu empresa." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.adrox.top/productos" />
        <link rel="canonical" href="https://www.adrox.top/productos" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Productos | Adrox Perú" />
      </Helmet>

      <div className="bg-white selection:bg-[#366D73]/20 selection:text-[#353E40]">
        <Navbar />

        {/* ============= HERO ============= */}
        <header className="relative pt-20 pb-16 sm:pb-24 overflow-hidden">
          {/* Dot grid */}
          <div
            className="absolute inset-0 -z-10"
            style={{
              backgroundImage: 'radial-gradient(#353E4014 1.5px, transparent 1.5px)',
              backgroundSize: '28px 28px',
            }}
          />
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_80%_50%_at_50%_-10%,#07F2F20d,transparent)]" />

          <div className="mx-auto max-w-5xl px-6 lg:px-8 pt-20 text-center">
            <h1
              data-aos="fade-up"
              data-aos-delay="100"
              className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-[#353E40] leading-[1.08]"
            >
              Todo lo que tu{' '}
              <span className="text-[#366D73]">empresa</span>
              <br />necesita.
            </h1>

            <p
              data-aos="fade-up"
              data-aos-delay="150"
              className="mt-6 text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed"
            >
              Explora nuestro catálogo de productos y soluciones tecnológicas. Selecciona la opción que mejor se adapte a tus necesidades.
            </p>
          </div>
        </header>

        {/* ============= GRID DE PRODUCTOS ============= */}
        <section className="border-t border-gray-100 py-16 sm:py-20">
          <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-10">
            <ProductosGrid />
          </div>
        </section>

        <Footer />
      </div>
    </>
  )
}
